import React from 'react'

export default function Divider({ custom = ''}) {
  return (
    <div className={`max-w-[150px] mx-auto bg-yellow-600 h-[1px] mb-4 ${custom}`}></div>
  )
}
